export default __webpack_public_path__ + "dist/media/projectYellowFolder.ded08b26.svg";